
import React, { useState } from "react";
import compLogo from './CA-Markets-Global-Logo-Colour-02.png'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SignatureCanvas from "react-signature-canvas";
import moment from 'moment-timezone';
import axios from 'axios';
import { ulid } from 'ulid';
const Input = ({ label, id, handleChange, name, type }) => (

    <>
        <div >
            <label htmlFor={id}>{label}</label>
            <input style={{ width: '150px', height: '40', fontSize: '15px', }} type={type || 'text'} id={id} name={name || id} onChange={handleChange} />
        </div>
        <br />
    </>
);

export default function Ibagreement() {
    let sign_base64
    const [sign, setSign] = useState();
    const [url, setUrl] = useState(null); // create a state that will contain our image url
    const [form, setFormValue] = useState({ form_data: '', name: '', email: '', form_name: 'IB反恶意刷单承诺书20241021', signature_base64: '', date: moment().tz('Asia/Shanghai').format(), id: ulid() });
    const [addnew, setAdd] = useState(false)

    const printDocument = () => {
        const input = document.getElementById("divToPrint");
        html2canvas(input).then((canvas) => {
            document.body.appendChild(canvas);
            var imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF();
            pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
            //pdf.output('dataurlnewwindow');
            pdf.save("IB协议反恶意刷单承诺书.pdf");
        });
    };

    const handleClear = () => {
        sign.clear()
    }

    async function fetchAdd() {

        var data = {
            "id": form.id,
            "full_name": form.name,
            "email": form.email,
            "form_name": form.form_name,
            "sign_base64": sign_base64,
            "date_create": form.date,
            "date_update": form.date,
            "doc_status": "pending",
            "client_type": "partner",
            "form_data": "",
            "remark": ""
        }

        var res = await axios.post(`https://51z378kvpi.execute-api.ap-east-1.amazonaws.com/prod/add?method=add`, JSON.stringify(data))
        return res
    }
    async function fetchUpdate() {

        var data = {
            "id": form.id,
            "full_name": form.name,
            "email": form.email,
            "form_name": form.form_name,
            "sign_base64": sign_base64,
            "date_create": form.date,
            "doc_status": "pending",
            "client_type": "partner",
            "form_data": "",
            "remark": ""
        }
        var res = await axios.post(`https://51z378kvpi.execute-api.ap-east-1.amazonaws.com/prod/add?method=update`, JSON.stringify(data))
        return res
    }

    async function handleGenerate() {
        setUrl(sign.getTrimmedCanvas().toDataURL('image/png'))
        sign_base64 = sign.getTrimmedCanvas().toDataURL('image/png')
        console.log(addnew)
        if (addnew) {
            var res = await fetchUpdate();
            //setFormValue({'date': moment().tz('Asia/Shanghai').format()})
            console.log(res)
            if (res.data.message === 'success') {
                alert('文档更新成功')

            } else {
                alert('文档更新失敗，請重試')

            }

        } else {

            var resad = await fetchAdd();
            //setFormValue({'date': moment().tz('Asia/Shanghai').format()})
            console.log(res)
            if (resad.data.message === 'success') {
                setAdd(true)
                alert('文档上存成功', addnew)

            } else {
                alert('文档上存失敗，請重試')

            }
        }
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setFormValue(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }

    // <div><a href="https://main.d2tj8hhau2jhnr.amplifyapp.com/"><img src={compLogo} alt="CA Markets Global. Logo" width="230" height="48" ></img></a></div> 


    return (

        <div className="grid gap-8">

            <div>

                <h1 className="mt-10 text-2xl font-medium text-center">代理（IB）协议、反恶意刷单承诺书</h1>

            </div>
            <div className="flex justify-center">
                <div className="flex-container">
                    <div style={{
                        backgroundColor: "#f5f5f5",
                        width: "210mm",
                        minHeight: "200mm",
             
                    }}>
                        <div>
                            <h4 className=" mt-10 mb-10 text-1xl font-medium text-center">请填写正确资料并签署</h4>
                            <div className = "justify-self-center">
                                <Input label="中文全名： " id="name" handleChange={handleChange} />
                                <Input label="电邮地址： " id="email" handleChange={handleChange} />
                            </div>
                            <div className = "justify-self-center" >客户签署： (请在框内签名)</div>
                            <div className = "justify-self-center mt-5">
                                <div className ="border border-blue-500 rounded" style={{  width: 350, height: 150, }}>
                                    <SignatureCanvas canvasProps={{ width: 349, height: 149, className: 'sigCanvas' }}
                                        ref={data => setSign(data)}
                                    />
                                </div>
                                <div style={{ paddingTop: '5px', padding: '5px', margin: 'auto', }}>
                                    <button class='button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded' onClick={() => handleClear()}>清除</button>
                                    <button class='ml-1 button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded' onClick={() => handleGenerate()}>保存资料及签名</button>
                                    <button class='ml-1 button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded' onClick={() => printDocument()}>下载协议</button>
                                </div>
                            </div>
                            <div className="mt-5 mb-2 justify-self-center max-w-sm rounded overflow-hidden shadow-lg">
                            <div className="px-2 py-4">
                                <p className="mb-2">使用说明：</p>
                                <p className="ml-5 mb-2">1. 如需重新签署，请点击"清除"按钮。</p>
                                <p class="ml-5 mb-2 break-words">2. 填写资料并完成签名后，点击"保存资料及签署"按钮确认。您的签名将显示在右侧协议中。</p>
                                <p className="ml-5 mb-2"></p>
                                <p className="ml-5 mb-2">3. 点击"下载协议"按钮将已签署的协议保存至您的设备。</p>
                                <p className="ml-5 mb-2">4. 点击<a href="https://main.d2tj8hhau2jhnr.amplifyapp.com/" class='button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded'>这里</a>返回协议主頁。</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center">
                <div className="flex-container">


                    <div>
                        <div className="square">
                            <div id="divToPrint"  style={{
                                backgroundColor: "#f5f5f5",
                                width: "210mm",
                                minHeight: "297mm",
               
                            }}>

                                <div className="">
                                    <div className="logo"><img src={compLogo} alt="CA Markets Global. Logo" width="230" height="48" /></div>
                                    <div className="content-header" >代理（IB）协议、反恶意刷单承诺书</div>
                                    <div className="content">
                                        <div style={{ paddingTop: "10px" }}>本协议由代理（IB）和CA Market Global Ltd.，科摩罗联邦安儒昂自治岛公司签订。</div>
                                        <div style={{ paddingTop: "10px" }}>IB的所有客户将在完全信息透明的基础上被提交给CA，其账户由CA提供。</div>
                                        <div style={{ paddingTop: "10px" }}>IB有权向CA发出指示，仅涉及与支付给IB的补偿相关的资金支付。</div>
                                        <div style={{ paddingTop: "10px", fontWeight: "700" }}>IB责任与保证</div>
                                        <div style={{ paddingTop: "10px" }}>IB承认其主要负责人已阅读并理解可能不时修改的CA账户开立文件，并同意按照其中包含的政策和条款开展业务。</div>
                                        <div style={{ paddingTop: "10px" }}>IB使用的所有使用开展业务的材料与手册必须建立在CA公司政策条款下。如果CA认为该材料可能具有误导性，CA</div>
                                        <div>保留否决使用此材料的权利。如果IB为了获取客户而在运营网站做广告宣传，IB则对其网站上发布的信息承担责任。</div>
                                        <div>CA可以要求IB向CA在个人推广的网页上进行修改或更改的信息。</div>
                                        <div style={{ paddingTop: "10px" }}>IB是指未被禁止订立和实施本协议条款的个人;或者法律实体，在这种情况下，IB正式组织并在其组建的管辖范围内</div>
                                        <div>具有良好的信誉，并且IB已获得正式授权并有权签订并实施本协议的条款IB仅对CA的产品和服务作出诚实和准确的</div>
                                        <div>陈述，不得对CA的产品和服务作出任何虚假陈述或其他不当行为,IB不会作为另一个人的代理人或代表人的IB。</div>
                                        <div style={{ paddingTop: "10px" }} >如果IB本人及其下面的客户被CA合规部门认定恶意交易者，那么IB和及其所属关联的客户都会根据实际情况进行可</div>
                                        <div>出恶意交易所产生的交易利润已经所有返佣。CA对此类情况拥有最终解释权。IB同意并承认CA有权禁止某些客户</div>
                                        <div style={{ paddingTop: "10px" }}>在CA开立账户或拒绝某些客户的开户申请。</div>
                                        <div style={{ paddingTop: "10px" }}>IB定期监督并在必要时报告IB客户账户中的任何可疑活动，以禁止流失，洗钱和所有其他欺诈活动。</div>
                                        <div style={{ paddingTop: "10px" }}>IB在本协议期间介绍给CA的所有客户，在本协议终止时仍为IB的客户。但是，本协议的任何一方均不得干扰客户</div>
                                        <div>维持其账户或将账户转入CA或从CA转账的权利。CA随时可以以书面形式通知另一方：</div>
                                        <div style={{ paddingTop: "10px" }}>
                                            如果IB有的任何陈述或保证都是不真实的，则CA在发出终止通知后立即生效。</div>
                                        <div style={{ paddingTop: "10px" }}>CA及其各集团公司保留在任何时候，无需满足任何先决条件的情况下，在通知或不通知的情况下，根据本条款</div>
                                        <div>采取任何行动的权利。</div>
                                        <div style={{ paddingTop: "10px" }}>本协议（包括所有已执行的修订和附件）代表双方就本协议主题达成的完整协议，并取代所有先前的协议，</div>
                                        <div>谅解，陈述，保证，提案和谈判请求（如果有）。</div>
                                        <div style={{ paddingTop: "10px", fontWeight: "700" }}>
                                            CA Markets Global 反恶意刷单承诺书：</div>
                                        <div style={{ paddingTop: "10px" }}>恶意刷单是指资管恶意操作客户的交易账户来获得高额佣金。恶意刷单不仅是违法的，还是违反道德原则和大部</div>
                                        <div>分法规的行为。</div>
                                        <div style={{ paddingTop: "10px" }}> 本人在这里承诺理解恶意刷单的含义并且在任一真实账户上都反对并拒绝恶意刷单行为。本人同意公司在以保</div>
                                        <div>护客户的政策前提下，如本人有恶意刷单行为，公司可以对此进行处理。</div>
                                        <div className="clientarea">
                                            <div>中文全名： {form.name}</div>
                                            <div>电邮地址： {form.email}</div>
                                            <div>签署日期：{form.date}</div>
                                            <div>签署</div>
                                            <br />
                                            <br />
                                            <img src={url} alt="" />

                                            <br />
                                            <br />

                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />

                                        <div style={{ fontSize: '10px' }}> 文档版本： {form.form_name} </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
           
        </div>

    );
}


